<template>
      <div class="vimeoPlayer"></div>
</template>

<script>
  import Player from '@vimeo/player'

  export default {
    name: 'VideoPlayer',
    // components: {
    //   Player
    // },
    props:[
      'vimeoId',
    ],
    data() {
      return {
        player: null
      };
    },
    methods: {
      install() {
        const vm = this;
        this.player = new Player( this.$el , {
          id: this.vimeoId,
          width: 640
        })
          .on("ended", function() {
            vm.close();
          })
      },
      close() {
        this.$emit('close');
      }
    },
    mounted() {
      this.install()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .vimeoPlayer{
            margin-top: 40px;
      }
</style>
